export enum CartOrderType {
  Mcfa = "MCFA",
  RapidParts = "Rapidparts",
  Both = "Both"
}
